<template>
  <div id="login">
    <div class="box">
      <img class="logo" src="/img/logo_top.png" />
      <div class="message error" v-show="error_message">
        {{ error_message }}
      </div>
      <div v-if="market === 'ES' || emailLogin">
        <input
          type="text"
          name="username"
          v-model="input.username"
          :placeholder="$t('login.email')"
          v-on:keyup.enter="login()"
        />
        <input
          type="password"
          name="password"
          v-model="input.password"
          :placeholder="$t('login.password')"
          v-on:keyup.enter="login()"
        />

        <button class="login" type="button" v-on:click="login()">{{ $t('login.access') }}</button>
      </div>
      <div v-if="market === 'PT' && !emailLogin">
        <button class="auth" @click="externalLogin()">
          <img class="icon" src="/img/mcdlogo.png">{{ $t('login.pt') }}
        </button>
      </div>
      <!-- <router-link to="/remember" class="remember">He olvidado la contraseña</router-link> -->
      <div v-if="market === 'ES'" class="remember" v-html="$t('login.forgot') + '<br>' + $t('login.contact')">
      </div>
      <div v-if="market === 'PT'" class="email-login" @click="emailLogin = !emailLogin">
        {{ !emailLogin ? 'Faça login com nome de utilizador e palavra-passe' : 'Faça login com o email' }}
      </div>

      <img class="itw" src="/img/logo_intowin.png" />
    </div>

    <div class="legal" :class="{ hide: !legaltherms }">
      <div class="page">
        <div class="text">
          <span class="title"
            >{{ $t('login.legal_terms.title') }}</span
          >

          <span class="content"
            >{{ $t('login.legal_terms.content') }}</span
          >
        </div>
      </div>
      <div class="button yes" @click="legalYes()">{{ $t('login.legal_terms.accept') }}</div>
      <div class="button no" @click="legalNo()">{{ $t('login.legal_terms.reject') }}</div>
    </div>
  </div>
</template>

<script>
// import router from '@/router';
import { Api } from "@/core/api.js";
import i18n from '@/i18n';
const api = new Api();

export default {
  name: "Login",
  data() {
    return {
      input: {
        username: "",
        password: ""
      },
      error_message: false,
      legaltherms: false,
      user_id: "",
      emailLogin: false
    };
  },
  computed: {
    market() {
      return this.$store.getters.getMarket;
    }
  },
  beforeRouteLeave(to, from, next) {
    // this.$overlay.hide();
    next();
  },
  methods: {
    login() {
      var validation = [];

      var username = this.input.username;
      // var password = sha256( this.input.password );
      var password = this.input.password;

      if (username.trim() == "" || username.trim().length <= 0) {
        validation.push(false);
      }
      if (password.trim() == "" || password.trim().length <= 0) {
        validation.push(false);
      }

      if (validation.indexOf(false) == -1) {
        var self = this;
        this.$overlay.loading();
        api
          .login({ username: username, password: password })
          .then(function(response) {
            // console.log("LOGIN");
            // console.log(response);
            if (response.status) {
              // self.$overlay.loading();
              if (response.data.user.active == "1") {
                self.legaltherms = true;
                self.user_id = response.data.user.id;
                self.$overlay.hide();
                return true;
              }
              self.error_message = false;
              self.$store.commit("user/setAuthenticate", response.data);

              var n = 0;
              var current = localStorage.site ? localStorage.site : false;

              // PARTNER CUSTOM ACCESS
              if (self.$store.getters["user/getType"] == "6") {
                self.$overlay.hide();
                self.$router.push("/partner/reports");
              }

              for (const key in response.data.restaurants) {
                if (response.data.restaurants.hasOwnProperty(key)) {
                  response.data.restaurants[key].available = true;

                  if (current == response.data.restaurants[key].site) {
                    response.data.restaurants[key].selected = true;
                    n = key;
                  } else {
                    response.data.restaurants[key].selected = n == 0;
                    if (n == 0) n = key;
                  }
                }
              }

              self.$store.commit("orders/cleanCart");
              if (response.data.sliders) {
                self.$store.commit("sliders/setSliders", response.data.sliders);
              }
              if (response.data.restaurants) {
                self.$store.commit(
                  "locations/setLocations",
                  response.data.restaurants
                );
              }
              if (response.data.restaurants) {
                self.$store.commit(
                  "locations/setSelectedLocation",
                  response.data.restaurants[n]
                );
              }
              self.$store.dispatch("loadTablesRelationship").then(function() {
                self.$store.dispatch("orders/loadOrders").then(function() {
                  self.$overlay.hide();

                  if (
                    self.$store.getters["user/getType"] == "4" ||
                    self.$store.getters["user/getType"] == "6"
                  ) {
                    self.$router.push("/admin/sections");
                  } else if (self.$store.getters["user/isAdmin"]) {
                    self.$router.push("/admin");
                  } else {
                    self.$router.push("/");
                  }
                });
              });
              // self.$destroy();
            } else {
              self.error_message = self.$t('login.error');
              self.$overlay.hide();
            }
          });
      } else {
        this.error_message = this.$t('login.error');
        self.$overlay.hide();
      }
    },
    externalLogin() {
      const accountId = "Ky9kaTJCOVZHRVZBS0Y1Z3NWWHFyUT09";
      api.externalLoginAdmin(accountId).then(response => {
        if (response.status) {
          window.location.href = response.data;
        }
      });
    },
    legalYes() {
      var self = this;
      this.$store.dispatch("user/acceptLegal", this.user_id).then(function() {
        self.login();
        self.legaltherms = false;
      });
    },

    legalNo() {
      this.legaltherms = false;
    },

    created() {
      this.$store.commit("user/setAuthenticate", false);
      
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('error') === 'auth') {
        this.error_message = this.$t('login.error');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#login {
  margin: auto;
  margin-top: 75px;
  padding: 20px;

  .box {
    max-width: 275px;
    width: 100%;
    margin: 0 auto;

    .logo {
      width: 100%;
      margin-bottom: 5px;
    }
    .auth {
      border-radius: 4px;
      font-family: Speedee-Bold;
      border: 1px solid #E2E2E2;
      color: #222222;
      text-align: left;
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 5px;
      box-shadow: 1px 1px 5px #F4F4F4;
      background-color: #222222;
      color: #fff;
      line-height: 18px;

      .icon {
          height: 40px;
          margin-right: 10px;
          background-color: #fff;
          padding: 6px;
          border-radius: 3px;
      }
    }
    .itw {
      margin-bottom: 5px;
      position: fixed;
      bottom: 25px;

      width: 150px;
      left: 50%;
      margin-left: -75px;
    }

    div {
      input {
        width: 100%;
        padding: 15px;
        margin-bottom: 5px;
        border: 1px solid #ccc;
        outline: none;
        font-size: 11pt;
        //background: #ddd;
        //border: none;
        //border-left: 35px solid var(--main_color);
        //border-right: 35px solid var(--main_color);

        &:focus {
          border: 1px solid var(--main_color);
        }
      }
      .login {
        width: 100%;
        padding: 15px;
        outline: none;
        border: none;
        cursor: pointer;
        font-size: 12pt;
        font-family: Speedee-Bold;
        margin-top: 5px;
        border-radius: 3px;
        text-transform: uppercase;
        transition: all 0.5s;
        background: #111;
        color: #fff;

        &:hover {
          background: var(--main_color);
          color: #111;
        }
      }
    }

    .remember {
      font-size: 10pt;
      margin-top: 20px;
      color: #888;
      cursor: default;
      display: block;
      text-decoration: none;

      &:hover {
        // text-decoration: underline;
      }
    }
    .email-login {
      font-size: 10pt;
      margin-top: 20px;
      color: #888;
      cursor: pointer;
      display: block;
      text-decoration: none;
    }
  }

  .legal {
    position: absolute;
    top: 20px;
    left: 50%;
    transform: translate(-50%);
    width: 50%;
    background-color: white;
    height: calc(100% - 40px);
    overflow: auto;

    &.hide {
      display: none;
    }

    .page {
      height: 90%;
      overflow: auto;
    }

    .text {
      margin: 50px;

      .title {
        display: block;
        margin-bottom: 20px;
      }

      .content {
        margin-top: 30px;
        display: block;
        font-size: 15px;
        text-indent: 1.5;
        text-align: left;
      }

      .corporation {
        margin: 100px 0;
        display: block;
        font-weight: bold;
        color: #777;
      }

      .small {
        font-size: 12px;
      }

      .confirm {
        display: block;
        margin: 60px 0;
        font-size: 16px;
        color: #444;
        font-weight: bold;
      }
    }

    .button {
      cursor: pointer;
      background-color: #eee;
      padding: 20px 30px;
      display: inline;
      position: fixed;
      bottom: 0px;
      width: 50%;
      font-size: 16px;

      &.yes {
        left: 0px;

        &:hover {
          background-color: #86c986;
          transition: 0.5s;
          color: black;
        }
      }

      &.no {
        &:hover {
          background-color: #c98686;
          transition: 0.5s;
          color: black;
        }
      }
    }
  }
}
</style>
